// components
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import SignInButton from '@/components/Navigation/SignInButton';
import PassportTransferFAQ from '@/components/passport/PassportTransferFAQ/PassportTransferFAQ';

// constants
import { PASSPORT_TRANSFER_NOT_SIGNED_IN_FAQ_BANK } from '@/components/passport/PassportTransferFAQ/PassportTransferFAQContent';

// styles
import styles from './PassportTransferSignedOut.module.scss';

export default function PassportTransferSignedOut() {
  return (
    <div className={styles.passport_transfer_signed_out} data-sentry-component="PassportTransferSignedOut" data-sentry-source-file="PassportTransferSignedOut.tsx">
      <h1>Sign In With Your Passport Account</h1>
      <p className={styles.passport_transfer_signed_out__description}>
        To transfer your Passport access to a different email, first sign in with the email you currently use to access Passport.
      </p>
      <SignInButton style="white" data-sentry-element="SignInButton" data-sentry-source-file="PassportTransferSignedOut.tsx"/>
      <PassportTransferFAQ faqBank={PASSPORT_TRANSFER_NOT_SIGNED_IN_FAQ_BANK} data-sentry-element="PassportTransferFAQ" data-sentry-source-file="PassportTransferSignedOut.tsx" />
    </div>
  )
}
